/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".pointer[_ngcontent-%COMP%]{cursor:pointer}.pointer[_ngcontent-%COMP%]:hover{border:1px solid #5d78ff}  .mat-menu-content{padding:10px}"];
export { styles as styles };
